export const setSessionStorageItem = (key: string, value: string): void => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.setItem(key, value);
    }
  } catch (error) {
    console.error(`Failed to set sessionStorage item ${key}:`, error);
  }
};

export const getSessionStorageItem = (key: string): string | null => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      return window.sessionStorage.getItem(key);
    }
  } catch (error) {
    console.error(`Failed to get sessionStorage item ${key}:`, error);
  }
  return null;
};

export const getSessionStartTime = (): string => {
  const storageKey = 'monoimin_session_started_at';
  let sessionStartedAt = getSessionStorageItem(storageKey);

  if (!sessionStartedAt) {
    sessionStartedAt = new Date().toISOString();
    setSessionStorageItem(storageKey, sessionStartedAt);
  }

  return sessionStartedAt;
};
